<template>
    <div class="relative flex h-full w-full items-center justify-center">
        {{ date.day }}
        <!-- Match the legend's compact dot/square spacing while keeping solid bars full-width. -->
        <calendar-availability-marker
            v-if="availability !== null"
            :status="availability"
            class="absolute bottom-1 left-1/2 -translate-x-1/2"
            :class="{
                '!w-[calc(100%-0.75rem)]':
                    availability === 'available' ||
                    availability === 'notOpenYet'
            }"
        />
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import CalendarAvailabilityMarker from './CalendarAvailabilityMarker.vue'
import {
    getCourseCalendarAvailability,
    type CourseCalendarInfo
} from './calendar-availability'

const props = defineProps<{
    datesToCourses: Map<string, CourseCalendarInfo>
    date: {
        year: number
        month: number
        day: number
    }
}>()

const dateString = computed(() => {
    return (
        String(props.date.year).padStart(4, '0') +
        '-' +
        String(props.date.month + 1).padStart(2, '0') +
        '-' +
        String(props.date.day).padStart(2, '0')
    )
})

// Dates without course data stay unmarked, including while availability loads.
const availability = computed(() => {
    return getCourseCalendarAvailability(
        props.datesToCourses.get(dateString.value)
    )
})
</script>
